import Datepicker from 'vanillajs-datepicker/js/Datepicker';
import nl from 'vanillajs-datepicker/js/i18n/locales/nl';
import fr from 'vanillajs-datepicker/js/i18n/locales/fr';
// import { jQuery } from 'jquery';
import tippy from '../components/layout/tippy';
import { beginCheckoutTrackingEvent } from '../components/gtm/eventTracking';
import { theme } from '../constants/defaults';
import freeShipping from '../components/free-shipping';

export default class Cart {
  constructor() {
    this.datepicker = null;
    this.datePickerElement = document.getElementById('cart-datepicker');
    this.datePickerInput = document.getElementById('datepicker-input');
    this.datePickerOverlay = document.querySelector('.js-datepicker-overlay');
    this.countryButtonBelgium = document.getElementById('country-belgium');
    this.countryButtonNetherlands = document.getElementById('country-netherlands');
    this.countryButtonFrance = document.getElementById('country-france');
    this.countryButtonLuxemburg = document.getElementById('country-luxemburg');

    this.tabSelectors = [...document.querySelectorAll('.js-tab-selector')];
    this.pickupPoints = null;
    this.pickupPointSelect = document.getElementById('pickupPoints');

    this.nationalHolidaysFrance = [
      '2023/04/07',
      '2023/04/10',
      '2023/05/01',
      '2023/05/08',
      '2023/05/18',
      '2023/05/29',
      '2023/07/14',
      '2023/08/15',
      '2023/11/01',
      '2023/11/11',
      '2023/12/25',
      '2023/12/26',
    ];
    this.nationalHolidaysBelgium = [];

    this.postalCodeInput = document.getElementById('postal-code');
    this.submitButton = document.getElementById('cart-submit');
    this.requiredElements = [...document.querySelectorAll('.js-required')] || [];
    this.requiredCount = 0;
    this.options = {
      daysOfWeekDisabled: [],
    };
    this.postalCodes = null;

    this.init();

    this.initialCartTotalPrice = window.cartTotalPrice;

    freeShipping(this.initialCartTotalPrice);
  }

  init() {
    this.fetchPickuppoints();

    if (this.datePickerElement) {
      this.fetchPostalCodes();
      this.eventListeners();
    }

    // this.inputMask();
    tippy();
  }

  fetchPostalCodes() {
    const { postalCodes } = this.datePickerElement.dataset;

    const request = new XMLHttpRequest();
    request.open('GET', postalCodes, false);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        this.postalCodes = JSON.parse(request.responseText);

        this.postalCodes.all = [...this.postalCodes['Tuesday/Friday']];

        this.fetchOpeningDays();
      }
    };
    request.onerror = () => {
      // There was a connection error of some sort
    };
    request.send();
  }

  fetchOpeningDays() {
    const request = new XMLHttpRequest();
    request.open('GET', '/apps/helper/opening-days', true);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        const data = JSON.parse(request.responseText);
        this.initDatepicker(data);
      }
    };
    request.onerror = () => {
      // There was a connection error of some sort
    };
    request.send();
  }

  fetchPickuppoints() {
    const request = new XMLHttpRequest();
    request.open('GET', '/apps/helper/pickup-points', true);
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        const data = JSON.parse(request.responseText);
        this.pickupPoints = data;

        // Loop through the array of pickupPoints and create option elements
        data.forEach(pickupPoint => {
          this.createpickupPointItem(pickupPoint);
        });
      }
    };
    request.onerror = () => {
      // There was a connection error of some sort
    };
    request.send();
  }

  createpickupPointItem(pickupPoint) {
    const pickupPointOption = document.createElement('option');
    pickupPointOption.setAttribute('data-pickup-id', pickupPoint.id);
    pickupPointOption.value = pickupPoint.name;
    pickupPointOption.textContent = `${pickupPoint.name} ${pickupPoint.address}`;

    // Append the option to the select element
    // this.pickupPointSelect.appendChild(pickupPointOption);
  }

  initDatepicker(data) {
    let datesDisabled = [];
    const deadline = data.order_deadline[0].split(':');
    const serverDate = data.server_date.replace(/-/g, '/');
    const minDate = new Date(serverDate);
    const now = new Date(serverDate);
    const {
      orderWeekdayBefore,
      language,
      noDelivery,
      exclusiveDelivery,
    } = this.datePickerElement.dataset;

    if (language) {
      this.options.language = language;
    }

    if (
      now.getHours() > parseInt(deadline[0], 10) ||
      (now.getHours() === parseInt(deadline[0], 10) &&
        now.getMinutes() >= parseInt(deadline[1], 10))
    ) {
      minDate.setDate(minDate.getDate() + 3);
    } else {
      minDate.setDate(minDate.getDate() + 2);
    }

    // Update min date if order before is set
    if (orderWeekdayBefore) {
      const weekdaysMap = {
        maandag: 1,
        dinsdag: 2,
        woensdag: 3,
        donderdag: 4,
        vrijdag: 5,
        zaterdag: 6,
        zondag: 0,
      };

      // replace weekdays by day number
      const weekdaysArray = orderWeekdayBefore
        .split(',')
        .map(item => {
          let formatItem = item;
          const keys = Object.keys(weekdaysMap);
          keys.forEach(key => {
            const value = weekdaysMap[key];
            formatItem = formatItem.replace(key, value);
          });
          return formatItem;
        })
        .sort();

      const currentWeekday = now.getDay();
      const beforeWeekdaySplit = weekdaysArray[0].split('-');
      const beforeWeekday = parseInt(beforeWeekdaySplit[0], 10);
      const beforeWeekdayTime = beforeWeekdaySplit[1].split(':');
      const beforeWeekdayTimeHours = parseInt(beforeWeekdayTime[0], 10);
      const beforeWeekdayTimeMinutes = parseInt(beforeWeekdayTime[1], 10);

      // Check if weekday is current weekday
      if (currentWeekday === beforeWeekday) {
        // Check if time is later than before order date time
        if (
          now.getHours() > beforeWeekdayTimeHours ||
          (now.getHours() === beforeWeekdayTimeHours &&
            now.getMinutes() >= beforeWeekdayTimeMinutes)
        ) {
          // 7 days of week - 1 day already set above
          minDate.setDate(minDate.getDate() + (7 - currentWeekday) - 1);
        }
      } else if (currentWeekday > beforeWeekday) {
        // Check if weekday is later than current weekday
        minDate.setDate(minDate.getDate() + (7 - currentWeekday) - 1);
      }
    }

    datesDisabled = [...data.closed[0]].map(dateString => {
      const parts = dateString.split('-');
      return new Date(parts[2], parseInt(parts[1], 10) - 1, parts[0]);
    });

    const openingDaysData = data.opening_days[0];
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, value] of Object.entries(openingDaysData)) {
      if (value === 0) {
        let keyValue = parseInt(key, 10) + 1;
        if (keyValue === 7) {
          keyValue = 0;
        }
        this.addItemsToArray(this.options.daysOfWeekDisabled, [keyValue]);
      }
    }

    if (noDelivery) {
      this.options.daysOfWeekDisabled = [1, 0];
      noDelivery.split(',').forEach(dayNumber => {
        if (dayNumber !== '') {
          this.addItemsToArray(this.options.daysOfWeekDisabled, [parseInt(dayNumber, 10)]);
        }
      });
    }

    this.options = {
      ...this.options,
      weekStart: 1,
      minDate,
      datesDisabled,
    };

    if (exclusiveDelivery && exclusiveDelivery !== '') {
      const dateSplit = exclusiveDelivery.split(',');
      const exclusiveDeliveryDates = [];

      dateSplit.forEach(exclusiveDeliveryDate => {
        const exclDateSplit = exclusiveDeliveryDate.split('-');
        exclusiveDeliveryDates.push(
          new Date(
            parseInt(exclDateSplit[0], 10),
            parseInt(exclDateSplit[1], 10) - 1,
            parseInt(exclDateSplit[2], 10),
          ),
        );
      });

      let newMinDate = exclusiveDeliveryDates[0];

      if (newMinDate < minDate) {
        newMinDate = minDate;
      }

      let newMaxDate = exclusiveDeliveryDates[exclusiveDeliveryDates.length - 1];

      if (newMaxDate < newMinDate) {
        newMaxDate = newMinDate;
        this.options.datesDisabled.push(new Date(newMinDate));
      }

      const calculateBetweenDates = (startDate, endDate) => {
        const dates = [];
        for (let date = new Date(startDate); date <= endDate; date.setDate(date.getDate() + 1)) {
          dates.push(new Date(date));
        }
        return dates;
      };

      const betweenDates = calculateBetweenDates(newMinDate, newMaxDate);

      const disabledDates = [
        ...new Set(
          betweenDates.filter(e => !exclusiveDeliveryDates.toString().includes(e.toDateString())),
        ),
      ];

      disabledDates.forEach(disabledDate => {
        this.options.datesDisabled.push(new Date(disabledDate));
      });

      this.options.minDate = newMinDate;
      this.options.maxDate = newMaxDate;
    }

    this.countriesDatesDisabled = {
      belgium: [...this.options.datesDisabled],
      netherlands: [...this.options.datesDisabled],
      france: [...this.options.datesDisabled],
      luxemburg: [...this.options.datesDisabled],
    };

    this.addDisableDates(this.nationalHolidaysFrance, 'france');
    this.addDisableDates(this.nationalHolidaysBelgium, 'belgium');

    Object.assign(Datepicker.locales, nl, fr);
    this.datePickerElement.innerHTML = '';
    this.datepicker = new Datepicker(this.datePickerElement, this.options);
    this.initialDaysOfWeekDisabled = Array.from(this.options.daysOfWeekDisabled);

    this.onDatepickerLoaded();

    // init text

    // if the url contains #pickup
    if (window.location.hash === '#pickup') {
      this.changePickupText('pickup');
    }
  }

  onDatepickerLoaded() {
    [...document.querySelectorAll('.js-on-datepicker-loaded')].forEach(el => {
      el.classList.remove('hide');
    });

    if (this.countryButtonBelgium.checked) {
      this.onChangeCountry(true, this.countryButtonBelgium.id);
    }

    if (this.countryButtonNetherlands.checked) {
      this.onChangeCountry(true, this.countryButtonNetherlands.id);
    }

    if (this.countryButtonFrance.checked) {
      this.onChangeCountry(true, this.countryButtonFrance.id);
    }

    if (this.countryButtonLuxemburg.checked) {
      this.onChangeCountry(true, this.countryButtonLuxemburg.id);
    }

    this.requiredElements.forEach(el => {
      if (el.checked) {
        this.requiredCount += 1;
      }
      this.submitButtonDisabledState();
    });
  }

  changePickupText(value) {
    // get card__datepicker-overlay-text element
    const datePickerOverlayText = document.querySelector('.card__datepicker-overlay-text');
    const datePickerLabel = document.querySelector('.datepicker__label');
    const cartHint = document.querySelector('.cart__hint');
    const cartAgree = document.querySelector('.js-cart-agree');
    const cartAgreeText = document.querySelector('.cart__aggree-text');
    const tip = cartAgree.querySelector('.js-tippy');
    const cartInfoFinancials = document.querySelector('.cart-info__financials');

    // get and save the innerhtml of the element
    const datePickerOverlayTextOriginal = `<p>${theme.strings.choose_location}</p>`;
    const datePickerLabelOriginal = `<p>${theme.strings.datepicker_label}</p>`;
    const cartHintOriginal = `<p>${theme.strings.cart_hint}</p>`;
    const cartAgreeOriginal = `<p>${theme.strings.cart_agree}</p>`;
    const cartInfoFinancialsOriginal = `<p>${theme.strings.cart_free_shipping}</p>`;

    // if value is pickup change the innerhtml of the element
    if (value === 'pickup') {
      datePickerOverlayText.innerHTML = `<p>${theme.strings.choose_pickup}</p>`;
      datePickerLabel.innerHTML = `<p>${theme.strings.datepicker_label_pickup}</p>`;
      cartHint.innerHTML = `<p>${theme.strings.cart_hint_pickup}</p>`;
      cartAgreeText.innerHTML = `${theme.strings.cart_agree_pickup}`;
      cartInfoFinancials.innerHTML = `${theme.strings.cart_free_shipping_pickup}`;

      // hide tip
      tip.style.display = 'none';
    } else {
      datePickerOverlayText.innerHTML = datePickerOverlayTextOriginal;
      datePickerLabel.innerHTML = datePickerLabelOriginal;
      cartHint.innerHTML = cartHintOriginal;
      cartAgreeText.innerHTML = cartAgreeOriginal;
      cartInfoFinancials.innerHTML = cartInfoFinancialsOriginal;

      // show tip
      tip.style.display = 'inline';
    }
  }

  onChangeTab(tab, pickupPoint, pickupId) {
    // get the value of data-tab-id attribute
    const value = tab.getAttribute('data-tab-id');
    // if tab is pickup tab disable postal code input
    if (value === 'pickup') {
      this.disablePostalCodeInput();
      this.onChangePickupPoint(pickupPoint, pickupId);
    } else {
      const cartAttribute = document.getElementById('pickupPointAttribute');

      // Set the value of the pickup point attribute to empty
      cartAttribute.setAttribute('value', 'delivery');

      const countrySelect = document.querySelector('.calendar__country-select');
      // loop over all inputs inside country select and get the selected country
      let selectedCountry = null;

      // get all inputs inside country select
      const countrySelectInputs = countrySelect.querySelectorAll('input');

      // loop over all inputs inside country select and get the selected country
      countrySelectInputs.forEach(input => {
        if (input.checked) {
          selectedCountry = input.value;
        }
      });

      // eslint-disable-next-line no-unused-expressions
      selectedCountry !== 'België' ? this.disablePostalCodeInput() : this.enablePostalCodeInput();

      this.options.datesDisabled = this.countriesDatesDisabled.belgium;
      this.refreshDatepicker();
      this.disableDatepicker();
    }

    this.changePickupText(value);
  }

  onChangePickupPoint(value, pickupId) {
    // Refresh the datepicker with force parameter set to true
    this.refreshDatepicker(true);

    // Convert pickupId from a string to a number
    const pickupIdInt = parseInt(pickupId, 10);

    if (value === 'choose') {
      // If 'choose' is selected, disable the datepicker
      this.disableDatepicker();
      this.refreshDatepicker();
    } else {
      // Find the pickup point with the selected pickupId
      const selectedPickupPoint = this.pickupPoints.find(point => point.id === pickupIdInt);

      if (selectedPickupPoint) {
        const shopName = selectedPickupPoint.shop;
        const shopAddress = selectedPickupPoint.address;
        const cartAttribute = document.getElementById('pickupPointAttribute');

        // Set the value of the pickup point attribute to the shop name
        cartAttribute.setAttribute('value', `${shopName}, ${shopAddress}`);

        // Get the dates disabled for the selected pickup point
        this.pickupDatesDisabled = selectedPickupPoint.days.closed.map(dateString => {
          const parts = dateString.split('-');
          return new Date(parts[2], parseInt(parts[1], 10) - 1, parts[0]);
        });

        const openingDays = selectedPickupPoint.days.opening_days;
        const openingDaysArray = [];

        // Iterate through openingDays and build openingDaysArray
        Object.values(openingDays).forEach((openingDay, index) => {
          if (openingDay === 0) {
            const closedDay = index + 1;

            if (closedDay < 7) {
              openingDaysArray.push(index + 1);
            } else {
              openingDaysArray.push(0);
            }
          }
        });

        // check current time
        const now = new Date();
        // check if current time is later than 13:59 on a Monday
        if (now.getDay() === 4) {
          // add the next saturday to the disabled dates
          const nextSaturday = new Date();
          nextSaturday.setDate(nextSaturday.getDate() + (6 - nextSaturday.getDay()));
          this.pickupDatesDisabled.push(nextSaturday);
        }

        // Update options with disabled dates and days of the week
        this.options.datesDisabled = this.pickupDatesDisabled;
        this.addItemsToArray(this.options.daysOfWeekDisabled, openingDaysArray);

        this.enableDatepicker();
        this.refreshDatepicker();
      } else {
        console.log('Pickup Point not found for ID:', pickupId);
      }
    }
  }

  onChangeCountry(showPostalCodeInput, country) {
    this.refreshDatepicker(true);

    if (showPostalCodeInput && country === 'country-belgium') {
      this.options.datesDisabled = this.countriesDatesDisabled.belgium;
      this.enablePostalCodeInput();
      this.refreshDatepicker();
      this.disableDatepicker();
    } else if (country === 'country-netherlands') {
      this.options.datesDisabled = this.countriesDatesDisabled.netherlands;
      this.disablePostalCodeInput();
      // NL: only on Friday
      this.addItemsToArray(this.options.daysOfWeekDisabled, [1, 2, 3, 4, 6, 0]);
      this.refreshDatepicker();
      this.enableDatepicker();
    } else if (country === 'country-luxemburg') {
      this.options.datesDisabled = this.countriesDatesDisabled.luxemburg;
      this.disablePostalCodeInput();
      // LUX: only on Friday
      this.addItemsToArray(this.options.daysOfWeekDisabled, [1, 3, 4, 6, 0]);
      this.refreshDatepicker();
      this.enableDatepicker();
    } else if (country === 'country-france') {
      this.options.datesDisabled = this.countriesDatesDisabled.france;
      this.disablePostalCodeInput();
      this.refreshDatepicker();
      this.enableDatepicker();
    }
  }

  addDisableDates(dates, country) {
    dates.forEach(date => {
      this.countriesDatesDisabled[country].push(new Date(date));
    });
  }

  onChangePostalCode() {
    const { value } = this.postalCodeInput;

    if (this.postalCodes.all.indexOf(value) > -1) {
      if (this.postalCodes['Tuesday/Friday'].indexOf(value) > -1) {
        this.addItemsToArray(this.options.daysOfWeekDisabled, [1, 3, 4, 6, 0]);
        this.refreshDatepicker();
      } else {
        this.refreshDatepicker(true);
      }
      this.enableDatepicker();
    } else if (value.length === 4) {
      this.enableDatepicker();
      this.refreshDatepicker(true);
    } else {
      this.disableDatepicker();
      this.refreshDatepicker(true);
    }
  }

  onChangeDate(date) {
    this.datePickerInput.setAttribute('value', this.formatDate(date));
    this.submitButtonDisabledState();
  }

  addPickupItem(variantId, quantity) {
    fetch('/cart/add.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        id: variantId,
        quantity,
      }),
    })
      .then(response => response.json()) // Parse the response as JSON
      .then(data => {
        // Log the item ID
        const { value } = this.submitButton.dataset;
        if (value) {
          beginCheckoutTrackingEvent(value);
        } else {
          beginCheckoutTrackingEvent(1);
        }

        window.cartItems = data.items;

        // simulate a click on the submit button
        this.submitButton.click();

        // form.submit();
      });
  }

  removePickupItem(variantId, quantity) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [variantId]: quantity, // Set quantity to 0 to remove the item
        },
        attributes: {
          pickuppoint: 'delivery',
        },
      }),
    })
      .then(response => response.json()) // Parse the response as JSON
      .then(data => {
        window.cartItems = data.items;

        this.submitButton.click();
      })
      .catch(error => {
        console.error('Error removing item:', error);
        // Handle the error if needed
      });
  }

  // Call the function to get the cart when needed

  onSubmit(event) {
    const targetId = 47005477601620;
    const { cartItems } = window;
    const itemExists = cartItems.some(item => item.id === targetId);

    if (window.location.hash === '#pickup') {
      if (itemExists) {
        console.log('item exists');
      } else {
        if (event) {
          event.preventDefault();
        }

        this.addPickupItem(targetId, 1);
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (itemExists) {
        if (event) {
          event.preventDefault();
        }

        this.removePickupItem(targetId, 0);
      } else {
        const { value } = this.submitButton.dataset;
        beginCheckoutTrackingEvent(value || 1);
      }
    }
  }

  submitButtonDisabledState() {
    if (this.requiredCount === this.requiredElements.length && this.datePickerInput.value) {
      this.submitButton.removeAttribute('disabled');
    } else {
      this.submitButton.setAttribute('disabled', '');
    }
  }

  enablePostalCodeInput() {
    this.postalCodeInput.removeAttribute('disabled');
    this.postalCodeInput.value = '';
  }

  disablePostalCodeInput() {
    this.postalCodeInput.setAttribute('disabled', '');
    this.postalCodeInput.value = '';
  }

  enableDatepicker() {
    this.datePickerOverlay.style.display = 'none';
    this.datePickerElement.classList.remove('disabled');
    this.datePickerElement.classList.add('enabled');
  }

  disableDatepicker() {
    this.datePickerOverlay.style.display = 'flex';
    this.datePickerElement.classList.remove('enabled');
    this.datePickerElement.classList.add('disabled');
  }

  refreshDatepicker(initialValues = false) {
    if (initialValues) {
      this.options.daysOfWeekDisabled = Array.from(this.initialDaysOfWeekDisabled);
    }
    this.datepicker.setDate({
      clear: true,
    });
    this.datepicker.setOptions(this.options);
    this.datePickerInput.setAttribute('value', '');
    this.submitButtonDisabledState();
  }

  eventListeners() {
    this.datePickerElement.addEventListener('changeDate', ({ detail }) => {
      const { date } = detail;
      this.onChangeDate(date);
    });

    this.postalCodeInput.addEventListener('input', () => {
      this.onChangePostalCode();
    });

    this.submitButton.addEventListener('click', event => {
      this.onSubmit(event);
    });

    this.countryButtonBelgium.addEventListener('click', () => {
      this.onChangeCountry(true, this.countryButtonBelgium.id);
    });

    this.countryButtonNetherlands.addEventListener('click', () => {
      this.onChangeCountry(false, this.countryButtonNetherlands.id);
    });

    this.countryButtonFrance.addEventListener('click', () => {
      this.onChangeCountry(false, this.countryButtonFrance.id);
    });

    this.countryButtonLuxemburg.addEventListener('click', () => {
      this.onChangeCountry(false, this.countryButtonLuxemburg.id);
    });

    this.tabSelectors.forEach(tab => {
      tab.addEventListener('click', () => {
        const { value } = this.pickupPointSelect.options[this.pickupPointSelect.selectedIndex];
        const pickupId = this.pickupPointSelect.options[
          this.pickupPointSelect.selectedIndex
        ].getAttribute('data-pickup-id');

        this.onChangeTab(tab, value, pickupId);
      });
    });

    this.pickupPointSelect.addEventListener('change', () => {
      // Get the value of the selected option
      const { value } = this.pickupPointSelect.options[this.pickupPointSelect.selectedIndex];

      // Get data-pickup-id attribute of the selected option
      const pickupId = this.pickupPointSelect.options[
        this.pickupPointSelect.selectedIndex
      ].getAttribute('data-pickup-id');

      // use function onchangePickupPoint and pass the value of the selected option
      this.onChangePickupPoint(value, pickupId);
    });

    this.requiredElements.forEach(el => {
      el.addEventListener('click', () => {
        if (el.checked) {
          this.requiredCount += 1;
        } else {
          this.requiredCount -= 1;
        }
        this.submitButtonDisabledState();
      });
    });
  }

  // inputMask() {
  //   this.postalCodeInputMask = IMask(this.postalCodeInput, {
  //     mask: '0000',
  //   });
  // }

  // format to mm/dd/yyyy
  formatDate(date) {
    const dateFormatted = new Date(date);
    const month = (dateFormatted.getMonth() + 1).toString().padStart(2, '0');
    const day = dateFormatted
      .getDate()
      .toString()
      .padStart(2, '0');
    const year = dateFormatted.getFullYear();
    return `${month}/${day}/${year}`;
  }

  addItemsToArray(array, items, unique = true) {
    items.forEach(item => {
      if (unique) {
        if (array.indexOf(item) < 0) {
          array.push(item);
        }
      } else {
        array.push(item);
      }
    });
  }
}
